import { Badge } from '@chakra-ui/react';
import * as React from 'react';

import { MembershipTermStatusAlert } from '@/graphql-types/globalTypes';

export const StatusAlertTag: React.FC<{
  statusAlert: MembershipTermStatusAlert;
}> = ({ statusAlert }) => {
  switch (statusAlert) {
    case MembershipTermStatusAlert.PAST_DUE:
      return (
        <Badge variant="solid" colorScheme="red">
          PAST DUE
        </Badge>
      );
    case MembershipTermStatusAlert.PAYMENT_NEEDED:
      return (
        <Badge variant="solid" colorScheme="yellow">
          UP FOR PAYMENT
        </Badge>
      );
    case MembershipTermStatusAlert.RECENTLY_LAPSED:
      return (
        <Badge variant="solid" colorScheme="red">
          RECENTLY LAPSED
        </Badge>
      );
    case MembershipTermStatusAlert.UP_FOR_RENEWAL:
      return (
        <Badge variant="solid" colorScheme="yellow">
          UP FOR RENEWAL
        </Badge>
      );
    default:
      return <>None</>;
  }
};
